<template>
  <div v-if="contact">
    <v-layout row class="pl-3 pr-3 mt-3">
    <v-flex md5 xs12>
      <v-card>
        <!-- Contact 1 Header -->
        <v-layout align-center row class="secondary white--text">
          <v-toolbar flat dark class="secondary">
            <v-icon medium dark>{{ contact.type === 'Customer' ? 'person' : 'person_outline' }}</v-icon>
            <v-toolbar-title>{{ contact.first_name }} {{ contact.last_name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="canEdit" outline @click="editContactDialog = true"><v-icon left>edit</v-icon>Edit</v-btn>
            <v-btn v-if="permissions.delete.all" outline class="red" @click="deleteContact"><v-icon color="red">delete</v-icon></v-btn>
          </v-toolbar>
        </v-layout>
        <v-layout row class="tertiary" v-if="assigned">
          <v-flex>
            <p class="caption white--text pl-2">Lead Assigned To:</p>
          </v-flex>
        </v-layout>
        <v-list>
          <!-- Contact 1 Phone -->
          <v-list-tile @click="contactLinks('phone', contact.phone_1)" v-if="contact.phone_1">
            <v-list-tile-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="title">
              <v-list-tile-title>{{ formatPhoneNumber(contact.phone_1) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ contact.phone_type_1 }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="contactLinks('phone', contact.phone_2)" v-if="contact.phone_2">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ formatPhoneNumber(contact.phone_2) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ contact.phone_type_2 }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <!-- Contact 1 Email -->
            <v-list-tile @click="contactLinks('email', contact.email)" v-if="contact.email">
              <v-list-tile-action>
                <v-icon color="primary">mail</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="title">{{ contact.email }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          <!-- Contact 2 Header -->
          <v-toolbar v-if="contact.secondaryContact_first_name" flat dark class="secondary">
            <v-icon medium dark>{{ contact.type === 'Customer' ? 'person' : 'person_outline' }}</v-icon>
            <v-toolbar-title>{{ contact.secondaryContact_first_name }} {{ contact.secondaryContact_last_name }}</v-toolbar-title>
          </v-toolbar>
          <!-- Contact 2 Phone -->
          <v-list-tile class="mt-2" @click="contactLinks('phone', contact.secondaryContact_phone_1)" v-if="contact.secondaryContact_phone_1">
            <v-list-tile-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ formatPhoneNumber(contact.secondaryContact_phone_1) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ contact.phone_type_1 }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="contactLinks('phone', contact.secondaryContact_phone_2)" v-if="contact.secondaryContact_phone_2">
            <v-list-tile-action></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ formatPhoneNumber(contact.secondaryContact_phone_2) }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ contact.secondaryContact_phone_type_2 }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <!-- Contact 2 Email -->
          <v-list-tile @click="contactLinks('email', contact.secondaryContact_email)" v-if="contact.secondaryContact_email">
            <v-list-tile-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title class="title">{{ contact.secondaryContact_email }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <!-- Address Information -->
          <v-toolbar v-if="contact.address" flat dark class="secondary">
            <v-icon medium dark>location_on</v-icon>
            <v-toolbar-title>Customer Address</v-toolbar-title>
          </v-toolbar>
          <v-list-tile class="mt-2" @click="contactLinks('address', contact.address + '-' + contact.zip)" v-if="contact.address">
            <v-list-tile-action>
              <v-icon color="primary">location_on</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ contact.address }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ contact.city }}, {{ contact.state }} {{ contact.zip }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
    <!-- Projects Information -->
    <!-- Active Projects -->
    <v-layout v-if="contact.type !== 'Lead'" column>
    <v-flex pl-4 md7 xs12>
      <v-card>
        <v-toolbar flat dark color="cyan">
          <v-icon medium dark class="pl-2">ballot</v-icon>
          <v-toolbar-title>Active Projects</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="$store.getters.user.permissions.projects.create" dark flat @click="createProjectDialog = true" @closeDialog="createProjectDialog = true">
          <v-icon left>add</v-icon>New Project
        </v-btn>
        </v-toolbar>
          <v-list two-line>
            <div v-if="activeProjects.length < 1" class="ml-5">No Active Projects</div>
            <template v-for="(project) in activeProjects">
              <v-container :key="project.name" style="cursor: pointer" @click="contactLinks('project', project.id)">
                <v-layout>
                  <v-flex xs12>
                    <p class="metrics title">{{ project.name }} #{{ project.job_number }}</p>
                    <p class="caption grey--text">{{ project.address }} {{ project.city }}, {{ project.state }} {{ project.zip }} | Gate Code: {{ project.gate_code }}</p>
                    <p class="caption black--text font-weight-bold">{{ project.status }}</p>

                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-around>
                  <v-flex xs3>
                    <p class="metrics primary--text display-1 text-xs-center">{{project.completedTasks}} <span class="caption">of</span> {{project.totalTasks}}</p>
                    <p class="caption text-xs-center">Tasks Completed</p>
                  </v-flex>
                  <v-flex xs3>
                    <p class="metrics red--text display-1 text-xs-center">{{project.pastDueTasks}}<span class="caption"></span></p>
                    <p class="caption text-xs-center">Tasks Past Due</p>
                  </v-flex>
                  <v-flex xs12>
                    <div class="w3-light-grey w3-round-xlarge" style="width:100%">
                      <div class="w3-container w3-blue w3-round-xlarge" :style="'width:' + project.progress + '%'">{{project.progress}}%</div>
                    </div>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-4"></v-divider>
              </v-container>
            </template>
        </v-list>
      </v-card>
    </v-flex>
    <!-- End: Completed Projects -->
    <v-flex pl-4 md7 xs12>
      <v-card>
        <v-toolbar flat dark color="success">
          <v-icon medium dark class="pl-2">ballot</v-icon>
          <v-toolbar-title>Completed Projects</v-toolbar-title>
        </v-toolbar>
          <v-list two-line>
            <div v-if="completedProjects.length < 1" class="ml-5">No Completed Projects</div>
            <template v-for="(project) in completedProjects">
              <v-container :key="project.name" style="cursor: pointer" @click="contactLinks('project', project.id)">
                <v-layout>
                  <v-flex xs12>
                    <p class="metrics title">{{ project.name }} #{{ project.job_number }}</p>
                    <p class="caption grey--text">{{ project.address }} {{ project.city }}, {{ project.state }} {{ project.zip }} | Gate Code: {{ project.gate_code }}</p>
                    <p class="caption black--text font-weight-bold">{{ project.status }}</p>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-4"></v-divider>
              </v-container>
            </template>
        </v-list>
      </v-card>
    </v-flex>
    </v-layout>
    <!-- End: Projects Section -->
    </v-layout>
    <!-- Edit Contact Dialog -->
    <v-dialog max-width="800px" persistent v-model="editContactDialog">
      <edit-contact :editContact="contact" v-if="editContactDialog" @closeDialog="editContactDialog = false" @contactChange="contactChange"/>
    </v-dialog>
  <!-- End: Edit Contact Dialog -->
  <!-- Create Project Dialog -->
  <v-dialog max-width="800px" persistent v-model="createProjectDialog">
    <create-project v-if="createProjectDialog" :contact="contact" @closeDialog="createProjectDialog = false"/>
  </v-dialog>
  <!-- End: Create Project Dialog -->
  </div>
</template>

<script>
import { db } from '../../firebaseInit'
import EditContact from './EditContact'
import CreateProject from '../projects/CreateProject'
import _ from 'lodash'

export default {
  props: ['id'],
  data () {
    return {
      createProjectDialog: false,
      editContactDialog: false,
      contact: null,
      assigned: null
    }
  },
  mounted () {
    this.$store.dispatch('contactProjects', this.id)
    this.getContact()
  },
  computed: {
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.contact.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.contacts
    },
    activeProjects () {
      return this.projects.filter(f => f.status !== 'Completed')
    },
    completedProjects () {
      return this.projects.filter(f => f.status === 'Completed')
    },
    projects () {
      const getProjects = _.orderBy(this.$store.getters.contactProjects, 'created_date', 'desc')
      let projectList = []
      getProjects.forEach(project => {
        const status = project.status
        if (project.tasks && project.tasks.length > 0) {
          const allTasks = project.tasks.filter(f => f.deleted === false)
          const totalTasks = allTasks.length
          const completedTasks = allTasks.filter(f => f.type === status && (f.status === 'Completed' || f.status === 'Not Applicable')).length
          const pastDueTasks = allTasks.filter(f => f.type === status && f.due_date.seconds < new Date().getTime() / 1000 && f.status !== 'Completed' && f.status !== 'Not Applicable').length
          const progress = totalTasks === 0 || completedTasks === 0 ? 0 : Math.round(completedTasks / totalTasks * 100)
          projectList.push({...project, totalTasks, completedTasks, pastDueTasks, progress})
        } else {
          projectList.push({...project, totalTasks: 0, completedTasks: 0, progress: 0, pastDueTasks: 0})
        }
      })
      return projectList
    }
  },
  methods: {
    deleteContact (item) {
      if (confirm('Are you sure you want to delete the contact ' + this.contact.first_name + ' ' + this.contact.last_name + '?')) {
        this.$store.dispatch('deleteContact', this.contact)
        this.$router.push('/customers')
      }
    },
    getContact () {
      db.collection('contacts').doc(this.id).get()
        .then(doc => {
          this.contact = {...doc.data(), id: doc.id}
        })
        .catch(error => console.log('Could not load contact data: ', error))
    },
    formatPhoneNumber (value) {
      let s2 = ('' + value).replace(/\D/g, '')
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/)
      return (!m) ? null : '(' + m[1] + ')' + ' ' + m[2] + '-' + m[3]
    },
    contactLinks (type, value) {
      // window.open('mailto: ' + value)
      if (type === 'email') {
        location.href = 'mailto: ' + value
      }
      if (type === 'phone') {
        location.href = 'tel:' + value
      }
      if (type === 'address') {
        window.open('https://www.google.com/maps?q=' + value)
      }
      if (type === 'project') {
        this.$router.push('/project/' + value)
      }
    },
    contactChange (value) {
      this.contact = {...this.contact, ...value}
    }
  },
  components: {
    EditContact,
    CreateProject
  }
}
</script>

<style>
.metrics {
  margin-bottom: 0px !important;
}
.w3-light-grey,
.w3-hover-light-grey:hover,
.w3-light-gray,
.w3-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
  width: 100%;
}
.w3-round-xlarge {
  border-radius: 16px;
}
.w3-blue,
.w3-hover-blue:hover {
  color: #fff !important;
  background-color: #2196f3 !important;
}
.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}
.w3-round-xlarge {
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/Contact.vue